import React from 'react';
import RadioSelect from '../../../FormElements/RadioSelect/RadioSelect';
import RadioGroup from '@material-ui/core/RadioGroup';
import Grid from '@material-ui/core/Grid';

export const validOptions = ["SI","WI"];

function Options(props) {
  
  const {configuration,createItem,setNextEnabled} = props;

  function handleChange(event, value) {
    setNextEnabled(true);
    createItem({id:"additionalOptions",value:value});
  }

  return (
    <RadioGroup
      aria-label="Additional Options"
      name="additionalOptions"
      onChange={handleChange}
      defaultValue={configuration["additionalOptions"] ? configuration["additionalOptions"] : ''}
    >
    <Grid container spacing={3}>
      <Grid item sm={4}>
        <RadioSelect value="N" label="None"/>
      </Grid>

      {(configuration.voltage === "Blank" && (parseInt(configuration.length) > 2 || (configuration.configurations != "Blank" && configuration.configurations != "C"))) ?
        <Grid item sm={4}>
          <RadioSelect value="EB" label="10W Emergency Battery Backup"/>
        </Grid>
        :
        <Grid item sm={4}>
          <RadioSelect value="EB" disabled={true} label="10W Emergency Battery Backup"/>
        </Grid>
      }
    
      {(configuration.voltage === "Blank" && (parseInt(configuration.length) > 2 || (configuration.configurations != "Blank" && configuration.configurations != "C"))) ?
        <Grid item sm={4}>
          <RadioSelect value="GT" label="Generator Transfer Device"/>
        </Grid>
        :
        <Grid item sm={4}>
          <RadioSelect value="GT" disabled={true} label="Generator Transfer Device"/>
        </Grid>
      }

      {(configuration.voltage === "Blank" && validOptions.includes(configuration.mountingOptions) && (parseInt(configuration.length) > 2 || (configuration.configurations != "Blank" && configuration.configurations != "C"))) ?
        <React.Fragment>
          <Grid item sm={4}>
            <RadioSelect value="DF" label="Dual Feed"/>
          </Grid>
          <Grid item sm={4}>
            <RadioSelect value="EBDF" label="10W Emergency Battery Backup with Dual Feed"/>
          </Grid>
        </React.Fragment>
        :
        <React.Fragment>
          <Grid item sm={4}>
            <RadioSelect value="DF" disabled={true} label="Dual Feed"/>
          </Grid>
          <Grid item sm={4}>
            <RadioSelect value="EBDF" disabled={true} label="10W Emergency Battery Backup with Dual Feed"/>
          </Grid>
        </React.Fragment>
      }

    </Grid>
    </RadioGroup>
  );
}

export default Options;